import { StringUtil } from "@mcleod/core";
import { AutogenLayoutGLAssignmentList } from "./autogen/AutogenLayoutGLAssignmentList";
import { Label, TableRowDisplayEvent } from "@mcleod/components";

export class GLAssignmentList extends AutogenLayoutGLAssignmentList {

    onLoad() {
        this.mainDataSource.search();
    }

    /** This is an event handler for the onRowDisplay event of tableGLAssignment. */
    tableGLAssignmentOnRowDisplay(event: TableRowDisplayEvent) {
        const labelIsActive: Label = event.target.findComponentById("labelAllowForRateExceptions") as Label;
        const tableRow = event.getTableRow();
        if (tableRow.data != null) {
            const modelRow = tableRow.data;
            labelIsActive.text = StringUtil.equalsIgnoreCase(modelRow.get("allow_for_rate_exceptions"), "Y") ? "Yes" : "No";
        }
    }
}
